import styled from "styled-components";
import { CardContainer } from "../Card/Card.styles";

export const HandContainer = styled.div<{ $count: number; $show: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: grid;
  grid-template-columns: repeat(
    ${({ $count }) =>
      `${$count}, min(var(--card-size), ${Math.round(100 / ($count || 1))}%)`}
  );
  justify-content: center;
  align-items: center;
  padding: ${({ $show }) => ($show ? "40px" : "0px")};
  height: ${({ $show }) => ($show ? "300px" : "0px")};
  overflow: visible;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  transition:
    height var(--dur-slow) var(--ease-bounce),
    padding var(--dur-slow) var(--ease-bounce),
    opacity var(--dur-base) var(--ease-out);

  ${CardContainer}${CardContainer} {
    cursor: pointer;
    /* the card is wider than its grid column: auto margins would collapse to
       zero and dump all the overflow on the right, pushing the fan off-center.
       margin: 0 lets the wrapper's align-items: center spill it evenly. */
    margin: 0;
  }

  ${CardContainer} {
    touch-action: manipulation;
  }

  @media (hover: hover) {
    ${CardContainer}:hover:not(.open) {
      rotate: 0deg;
      translate: 0 -20%;
      box-shadow: 0 var(--lip) 0 var(--line-strong), var(--shadow-float);
    }

    /* the hover lift pulls the card up out from under the pointer, which drops
       the hover, drops the card, and hands the pointer to the card behind. this
       pad backfills the vacated strip so the pointer keeps the card it picked.
       inert until hovered, so it never steals clicks from its neighbours. */
    ${CardContainer}:not(.open)::after {
      content: "";
      position: absolute;
      inset: 0 0 -25% 0;
      pointer-events: none;
    }

    ${CardContainer}:hover:not(.open)::after {
      pointer-events: auto;
    }
  }
`;
